import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@doxyme/ui';
import './tooltip-for-trimmed-text.scss';
export const TooltipForTrimmedText = ({ value, }) => {
    const ref = useRef(null);
    const [isTrimmed, setTrimmed] = useState(false);
    useEffect(() => {
        setTrimmed(ref.current.offsetWidth < ref.current.scrollWidth);
    });
    return (<div className="tooltip-trimmed-text" ref={ref}>
      {isTrimmed && (<Tooltip tabIndex={-1} content={value} size="large" theme="light" pointerPosition="top-left" hideTimeout={0} debounceMs={0}/>)}
      <span>{value}</span>
    </div>);
};
